import { render, staticRenderFns } from "./addressBookEntry.vue?vue&type=template&id=2a2b9dde&scoped=true&"
import script from "./addressBookEntry.vue?vue&type=script&lang=js&"
export * from "./addressBookEntry.vue?vue&type=script&lang=js&"
import style0 from "./addressBookEntry.vue?vue&type=style&index=0&id=2a2b9dde&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2b9dde",
  null
  
)

export default component.exports